import { ICellRendererParams } from 'ag-grid-community';
import { Component, inject } from '@angular/core';
import { WatchAlert } from '@compumark/order-management-client';

import { AlertApiClientService } from '../../services/alert-api-client.service';

@Component({
  selector: 'app-status-renderer',
  templateUrl: './status-renderer.component.html',
  styleUrls: ['./status-renderer.component.scss'],
  standalone: false,
})
export class StatusRendererComponent {
  private alertApiClientService = inject(AlertApiClientService);

  params!: ICellRendererParams;
  isEnabled?: boolean;
  watchAlert!: WatchAlert;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.watchAlert = params.data as WatchAlert;
    this.isEnabled = this.watchAlert.enabled;
  }

  onStatusChange(): void {
    this.isEnabled = !this.isEnabled;
    this.watchAlert.enabled = this.isEnabled;
    this.alertApiClientService
      .updateAlert(this.watchAlert)
      .subscribe((updated) => {
        this.params.node.setData(updated);
      });
  }
}
